module.exports = __webpack_public_path__ + "img/capaLivros.1af235f7.jpg";